<template>
  <v-snackbar v-if="newHTMLVersionDetected" :value="true" bottom :timeout=0>
    Se ha detectado una nueva versión de la aplicación.
      <v-btn color="pink" text @click=reloadApp>
        Actualizar
      </v-btn>
  </v-snackbar>
</template>

<script>
import * as Sentry from '@sentry/browser'

const defaultProps = {
  url: '/',
  delay: 10 * 60 * 1000 // 10 minutes
}

export default {
  data () {
    return {
      newHTMLVersionDetected: false
    }
  },

  methods: {
    fetchSource () {
      return fetch(`${defaultProps.url}?${(new Date()).getTime()}`)
        .then(response => {
          if (response.status !== 200) {
            throw new Error("We couldn't fetch HTML page to verify version")
          }
          return response.text()
        })
        .then(html => {
          const hash = this.hash(html)
          if (!this.previousHash) {
            this.previousHash = hash
            return
          }
          if (this.previousHash !== hash) {
            this.previousHash = hash
            this.newHTMLVersionDetected = true
            clearInterval(this.interval)
          }
        })
        .catch(error => {
          Sentry.captureException(error)
        })
    },
    hash (str) {
      const len = str.length
      let hash = 0
      if (len === 0) return hash
      let i
      for (i = 0; i < len; i++) {
        hash = ((hash << 5) - hash) + str.charCodeAt(i)
        hash |= 0 // Convert to 32bit integer
      }
      return hash
    },
    reloadApp (e) {
      window.location.reload()
      e.preventDefault()
    }
  },

  mounted () {
    this.fetchSource()
    this.interval = setInterval(this.fetchSource, defaultProps.delay)
  }
}
</script>
